import { useTranslation } from "react-i18next";

export default function ViewEditDiv({
  title,
  value,
  divClasses,
  pClasses,
  spanClasses,
  editMode,
  InputElement,
}) {
  const { t } = useTranslation("general");

  return (
    <div className={divClasses}>
      <p className={pClasses ? pClasses : ""}>{t(title)}:</p>
      {editMode ? InputElement : <span>{value ?? "-"}</span>}
    </div>
  );
}
